import { render, staticRenderFns } from "./BasicGeneralInventoryReport.vue?vue&type=template&id=09a6e35c&"
import script from "./BasicGeneralInventoryReport.vue?vue&type=script&lang=js&"
export * from "./BasicGeneralInventoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports